export default function ContactEntry() {
  return (
    <section id="contact" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
              <i className="ri-mail-send-line"></i>
              <span>欢迎联系</span>
            </div>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
              联系我们
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mt-4 max-w-lg">
              如果你有视频资源推荐、内容合作需求或任何意见建议，
              欢迎通过以下方式联系我们。我们重视每一位用户的反馈。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4 mt-6">
              <div className="flex items-center gap-3 px-5 py-3 bg-background-50 rounded-xl border border-background-200/70">
                <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center">
                  <i className="ri-mail-line text-primary-500 text-lg"></i>
                </div>
                <div className="text-left">
                  <div className="text-xs text-foreground-500">商务合作</div>
                  <div className="text-sm font-medium text-foreground-800">contact@mitao.video</div>
                </div>
              </div>
              <div className="flex items-center gap-3 px-5 py-3 bg-background-50 rounded-xl border border-background-200/70">
                <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center">
                  <i className="ri-customer-service-2-line text-accent-500 text-lg"></i>
                </div>
                <div className="text-left">
                  <div className="text-xs text-foreground-500">内容投稿</div>
                  <div className="text-sm font-medium text-foreground-800">submit@mitao.video</div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex-shrink-0 w-full max-w-md">
            <div className="bg-background-50 rounded-2xl border border-background-200/70 p-6">
              <h3 className="text-base font-semibold text-foreground-900 mb-4">快速留言</h3>
              <div className="space-y-3">
                <input
                  type="text"
                  placeholder="你的称呼"
                  className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-200/70 bg-background-50 text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-300 transition-colors"
                />
                <input
                  type="text"
                  placeholder="你的邮箱"
                  className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-200/70 bg-background-50 text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-300 transition-colors"
                />
                <textarea
                  placeholder="留言内容（500字以内）"
                  rows={3}
                  maxLength={500}
                  className="w-full px-4 py-2.5 text-sm rounded-lg border border-background-200/70 bg-background-50 text-foreground-800 placeholder:text-foreground-400 outline-none focus:border-primary-300 transition-colors resize-none"
                />
                <button className="w-full py-2.5 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                  发送留言
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}